import React from "react";
import NewOrderLine from "./newOrderLine";
import OrderLine from "./orderLine";
import { useTranslation } from "react-i18next";
import { OrderBuilderLine as Line } from "./orderLine/type";

export default function CurrentOrder({
  lines,
  addLine,
  removeLine,
  updateLineQuantity,
}: {
  lines: Line[];
  addLine: (line: Line) => void;
  removeLine: (lineId: number) => void;
  updateLineQuantity: (lineId: number, newQuantity: number) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="currentOrder box">
      <span>{t("translation:order_lines")}</span>
      {lines.map((line) => (
        <OrderLine
          key={line.id}
          line={line}
          removeLine={removeLine}
          updateLineQuantity={updateLineQuantity}
        />
      ))}
      <NewOrderLine addLine={addLine} />
    </div>
  );
}
